/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VoucherEmissioneRigaFallitaDTO } from './voucher-emissione-riga-fallita-dto';


export interface VoucherEmissioneSummaryDTO { 
    /**
     * Voucher creati ex-novo
     */
    emessi?: number;
    /**
     * Voucher esistenti con importo incrementato (idempotenza + incremento)
     */
    aggiornati?: number;
    /**
     * Voucher esistenti invariati (no-op sulla riga)
     */
    invariati?: number;
    /**
     * Righe che hanno sollevato un errore e sono state saltate
     */
    fallite?: number;
    /**
     * Righe finanziate della graduatoria confermata processate
     */
    righe_finanziate?: number;
    /**
     * Dettaglio delle righe fallite: quale pratica e perché
     */
    dettaglio_fallite?: Array<VoucherEmissioneRigaFallitaDTO>;
}

